// ========================================
// utils/axiosConfig.js - Axios Interceptor for Auth
// ========================================
// PURPOSE: Handle 401 unauthorized responses globally
// - Clears localStorage when token expires
// - Redirects to appropriate login page based on current path
// ========================================

import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

// Request interceptor - add token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    // Check if this is an admin request
    const isAdminRequest = config.url.includes('/admin/');
    
    if (isAdminRequest) {
      const adminToken = localStorage.getItem('adminToken');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 unauthorized
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Check if this was an admin request
      const isAdminRequest = error.config?.url?.includes('/admin/');
      
      if (isAdminRequest) {
        // Admin token expired - clear admin storage
        localStorage.removeItem('adminToken');
        localStorage.removeItem('admin');
        window.location.href = '/admin/login';
      } else {
        // User token expired - clear user storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;